import React from 'react'
import { Editable, PrettyNumber } from '@ui'
import { NumberType } from '@api'
import { FormGroup, InputGroup, Intent } from '@blueprintjs/core'
import Label from './Label'

interface IProps {
  error?: string
  editing: boolean
  numberType?: NumberType
  required?: boolean
  hint?: string
  label: React.ReactNode
  value: any
  onChange: (val: any) => void
  'data-input'?: string
}

export default function Text({
  error,
  editing,
  required,
  hint,
  label,
  numberType,
  value = '',
  onChange,
  'data-input': dataInput,
}: IProps) {
  const intent = error ? Intent.DANGER : undefined
  return (
    <>
      <Label {...{ editing, hint, label, required }} />
      <Editable editing={editing}>
        <PrettyNumber {...{ value, numberType, 'data-input': dataInput }} />
        <FormGroup {...{ helperText: error, intent, style: { width: '100%' } }}>
          <InputGroup {...{ value, onChange, intent }} type="number" data-input={dataInput} />
        </FormGroup>
      </Editable>
    </>
  )
}
